import { getStorage, setStorage, storageKey } from '@/utils/storage'

export default {
	SET_SECRECY(state, secrecy) {
		setStorage(storageKey.secrecy, secrecy);
		state.secrecy = secrecy;
	},
	SET_USER(state, user) {
		setStorage(storageKey.user, user);
		state.user = user;
	},
	// storeName  店铺名称 不超过255位
	// usedPos  是否使用过收银系统
	// industry  所属行业
	// storeNum  门店数量
	// investmentAmount  门店平均投资
	SET_USER_FIELD(state, { key, value }) {
		let userJson = getStorage(storageKey.user);
		if (user === null) return;
		let user = JSON.parse(userJson);
		user[key] = value;
		setStorage(storageKey.user, user);
		state.user = user;
	}	
}


// WEBPACK FOOTER //
// ./src/store/mutations.js